import {getClientQueryOptions} from "@project/application/sales/clients";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {ClientPage} from "./-page/client.page";
import {ClientPending} from "./-page/client.pending";

const clientSearchSchema = z.object({
  includeDeleted: z.boolean().default(false),
});

export const Route = createFileRoute("/_app/sales/clients/$clientId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  validateSearch: clientSearchSchema,
  loaderDeps: ({search}) => ({includeDeleted: search.includeDeleted}),
  loader: async ({context: {queryClient}, deps, params}) =>
    queryClient.ensureQueryData(getClientQueryOptions(params.clientId, deps.includeDeleted)),
  pendingComponent: ClientPending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) => getClientCompanyName(data),
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.clientById.id,
        values: {clientId: p["clientId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {clientId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <ClientPage clientId={clientId} includeDeleted={includeDeleted} />;
}

function getClientCompanyName(data: unknown) {
  if (
    typeof data !== "object" ||
    data === null ||
    !("company" in data) ||
    typeof data.company !== "object" ||
    data.company === null ||
    !("companyName" in data.company) ||
    typeof data.company.companyName !== "string"
  ) {
    return undefined;
  }

  return data.company.companyName;
}
